if (!customElements.get('card-swiper-button-download')) {

    class CardSwiperButtonDownload extends HTMLElement {
        constructor() {
            super();
            this._swiperInstance = null;
            this._swiperContainer = this;

            this.initSwiper();
        }

        initSwiper(params) {
            const nextButton = this.querySelector('.swiper-btn-next');
            const prevButton = this.querySelector('.swiper-btn-prev');

            const swiperConfig = {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 12,
                direction: "horizontal",
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                }
            };

            this._swiperInstance = new Swiper(this._swiperContainer, swiperConfig);

        }
    }

    customElements.define('card-swiper-button-download', CardSwiperButtonDownload);
}